import { green, grey, orange, red, yellow } from "@mui/material/colors";

export const light = {
	primary: {
		main: "#3899EC",
		light: "#CAE0E7",
		dark: "#2B7CD3",
		contrastText: "#ffffff",
	},
	secondary: {
		main: "#3083dcff",
		light: "#E0F0F6",
		dark: "#27578aff",
		contrastText: "#3D3D3D",
	},
	error: {
		main: red[600],
		light: red[50],
		dark: red[700],
		contrastText: "#ffffff",
	},
	warning: {
		main: yellow[800],
		light: yellow[100],
		dark: yellow[900],
		contrastText: "#ffffff",
	},
	success: {
		main: green[600],
		light: green[50],
		dark: green[700],
		contrastText: "#ffffff",
	},
	info: {
		main: "#3899EC",
		light: "#CAE0E7",
		dark: "#2B7CD3",
		contrastText: "#ffffff",
	},
	progress: {
		main: orange[700],
		light: orange[50],
		dark: orange[800],
		contrastText: "#ffffff",
	},
	default: {
		main: grey[500],
		light: grey[50],
		dark: grey[700],
		contrastText: "#ffffff",
	},
	divider: grey[100],
};
